import React, { useMemo } from "react";

import DotMenu from "./dotmenu";

import { config } from "../constant";
import { commonFunction } from "../common-functions";
import { downloadOutputFile } from "../../utils";

const ApprovalBlock = (props) => {
  const { USER_ROLES } = config;
  const { approval, userId, onDecision, onDelete, nanobar } = props;

  const { 
    _id, outputFileName, outputFile, createdAt, requesterEmail, approvedBy = [], requesterUserId,
    status, approvers, approverDetails, currentApproverIndex, rejectedBy = {}, outputFileId = ""
  } = approval;
  const { filename, size } = outputFile;
  const iAmApprover = approvers.includes(userId);
  const fileNameToShow = outputFileName || filename;
  const approvedByObj = useMemo(() => {
    return approvedBy.reduce((acc, item) => {
      acc[item.userId] = item;
      return acc;
    }, {});
  }, [approvedBy]);
  const rejectedUserIdIndex = useMemo(() => {
    return rejectedBy.userId ? approvers.findIndex(curApproverId => curApproverId === rejectedBy.userId) : Infinity;
  }, [approvers, rejectedBy]);

  const {getDateFormat, getFileSize, getIcon} = commonFunction;

  return (
    <div className="approval-block">
      <div className="flex-container with-gap no-margin vertical-middle info-section">
        <div className="flexbox no-margin file-icon">
          <img 
            src={getIcon(fileNameToShow)}
            className="icon"
            alt="template type"
          />
        </div>
        <div className="flexbox no-margin">
          <div className="top-section flex-container column no-margin">
            <div className="flex-container with-gap no-margin">
              <div className="flex-container with-gap no-margin vertical-middle">
                <div className="title">{fileNameToShow}</div>
                <div className={`status-pill text-uppercase ${status}`}>
                  {status === "in_progress" ? "in progress" : status}
                </div>
              </div>
              <div className="flex-container with-gap no-margin vertical-middle">
                <div className="key-value">
                  <span className="key">Size</span>
                  <span className="value">{getFileSize(size)}</span>
                </div>
                <DotMenu
                  submenus={[
                    {title: "Download", click: () => downloadOutputFile(nanobar, outputFileId, fileNameToShow)},
                    ...(requesterUserId === userId ? [{title: "Delete...", click: () => onDelete(_id)}] : [])
                  ]}
                />
              </div>
            </div>
            <div className="key-value">
              <div className="key">Requested by</div>
              <div className="value fixed-width defined" title={requesterEmail}>{requesterEmail}</div>

              <span className="key">Requested on</span>
              <span className="value">{getDateFormat(createdAt)}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="line-separator less-margin"/>
      <div className="timeline-view flex-container no-margin column">
        {approvers.map((curApproverId, index) => {
          const { name = "", email = "", role = "" } = approverDetails[curApproverId] || {};
          const isCurrentUser = userId === curApproverId;
          const isCurrentItem = index === currentApproverIndex;
          const state = (
            index < currentApproverIndex || status === "approved" ? "done" : (
              status === "rejected" ? "rejected" : (isCurrentItem ? "current" : "upcoming")
            )
          );
          const initial = (name || email).trim()[0];
          const canAct = iAmApprover && isCurrentUser && isCurrentItem && state !== "done" && state !== "rejected";
          
          const alreadyApproved = approvedByObj[curApproverId] !== undefined;
          const alreadyRejected = rejectedBy.userId === curApproverId;
          
          return (
            <div key={`${_id}-${curApproverId}`}
              className={`flex-container no-margin vertical-middle flex-start milestone ${state}`}
            >
              <div className="flex-container no-margin vertical-middle rail">
                <span className={`dot ${state}`}/>
                {index !== approvers.length - 1 && <span className="connector" />}
              </div>

              <div className="flex-container no-margin with-gap vertical-middle details">
                <div className="flex-container no-margin with-gap vertical-middle person">
                  <div className="avatar text-uppercase">{initial}</div>
                  <div className="info">
                    <div className="name">
                      {userId === curApproverId ? `${name} (You)` : name}
                      <span className="role text-uppercase">{USER_ROLES[Number(role) - 1]}</span>
                    </div>
                    <div className="email">{email}</div>
                  </div>
                </div>
                <div className="actions">
                  {canAct && (
                    <div className="btn-container flex-container no-margin with-gap">
                      <button
                        className="btn moral"
                        onClick={() => onDecision("approve", approval)}
                      >Approve</button>
                      <button
                        className="btn"
                        onClick={() => onDecision("reject", approval)}
                      >Reject</button>
                    </div>
                  )}
                  {!canAct && index <= rejectedUserIdIndex && (
                    <span className={`awaiting-approval ${alreadyApproved ? "approved" : (
                      alreadyRejected ? "rejected" : ""
                    )}`}>
                      {alreadyApproved ? `Approved${isCurrentUser ? " by you" : ""} on ${getDateFormat(approvedByObj[curApproverId].approvedAt)}` : (
                        alreadyRejected ? `Rejected${isCurrentUser ? " by you" : ""} on ${getDateFormat(rejectedBy.rejectedAt)}` : "Awaiting approval"
                      )}
                    </span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  )
};

export default ApprovalBlock;
